import _                                                   from 'underscore';
import classNames                                          from 'classnames';
import React, { FC, ReactNode }                            from 'react';
import { Cell, Grid }                                      from "styled-css-grid";
import { Divider, Header, Icon, IconProps, SemanticICONS } from 'semantic-ui-react';

import { CorvalUIColor, Size, SystemEvent }      from '../../types';
import { FinePrintMessage }                      from '../components/util/messaging/FinePrintMessage';
import { StyledContainer, StyledContainerProps } from './StyledContainer';


interface Props {
    title: string,
    onTitleClick?: ( e: SystemEvent ) => void,
    description?: string,
    descriptionContent?: ReactNode,
    icon?: SemanticICONS | IconProps,
    iconSpace?: number,
    iconCentered?: boolean,
    containerProps?: StyledContainerProps,
    utilityContent?: ReactNode,
    utilityContentAligned?: boolean,
    withDivider?: boolean,
}

const defaultProps: Props = {
    title:                 'Details',
    onTitleClick:          null,
    description:           null,
    descriptionContent:    null,
    icon:                  'cube',
    iconSpace:             40,
    iconCentered:          false,
    containerProps:        {},
    utilityContent:        null,
    utilityContentAligned: false,
    withDivider:           true,
}

const DialogIntroductionContainer: FC<Props> = ( props ) => {

    let isClickable    = _.isFunction( props.onTitleClick ),
        hasDescription = ( props.description || props.descriptionContent ),
        hasAlignedUtil = props.utilityContentAligned;

    let iconProps = {
        fitted: true,
        size:   'large',
        color:  isClickable ? 'purple' : 'teal',
        ...( _.isObject( props.icon )
             ? props.icon : {
                name: props.icon,
            } )
    } as IconProps;

    return (

        <>
            <StyledContainer padding={ Size.MD } bgColor={ CorvalUIColor.LUNAR } { ...props.containerProps }>

                <Grid rows={ 'auto auto' } columns={ `${ props.iconSpace }px 1fr ${ _.isNull( props.utilityContent ) ? 'auto' : 'minmax(120px,auto)' }` } columnGap={ '0px' } rowGap={ ( hasDescription || !hasAlignedUtil ) ? '10px' : '0px' }>

                    <Cell middle className={ classNames( { 'cursor--pointer': isClickable } ) } center={ props.iconCentered } left={ 1 } width={ 1 } top={ 1 } onClick={ props.onTitleClick }>

                        <Icon { ...iconProps } />

                    </Cell>
                    <Cell middle className={ classNames( { 'cursor--pointer': isClickable } ) } left={ 2 } width={ hasAlignedUtil ? 1 : 2 } top={ 1 } onClick={ props.onTitleClick }>

                        <Header as={ 'h3' } color={ 'purple' }>{ props.title }</Header>

                    </Cell>

                    { hasDescription && (
                        <Cell left={ 2 } width={ 1 } top={ 2 } className={ classNames( { 'padding-sm-right': !hasAlignedUtil } ) }>

                            { props.description && <FinePrintMessage>{ props.description }</FinePrintMessage> }
                            { props.descriptionContent }

                        </Cell>
                    ) }

                    <Cell middle left={ 3 } width={ 1 } top={ hasAlignedUtil ? 1 : 2 } className={ 'flexbox flexbox--align-end flexbox--justify-end' }>

                        { props.utilityContent }

                    </Cell>
                </Grid>

            </StyledContainer>

            { props.withDivider && <Divider className={ 'no-margin' }/> }
        </>
    );
};

DialogIntroductionContainer.defaultProps = defaultProps;

export { DialogIntroductionContainer }
